import { UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

import { createCombinedPasswordValidationRegex, createDoNotAcceptWithoutAlphanumericRegex, hasPhoneValue, isPhoneValid } from '../signup/signup-form-utils';

export enum ActivationSteps {
  UserInfo = 'UserInfo',
  PhoneVerification = 'PhoneVerification',
  Password = 'Password',
}

export interface AccountActivationStepProps {
  form: UseFormReturn<ActivateAccountFormData>;
  onNextStep?: () => void;
  workspaceName?: string;
  onTermsAndConditionsChange?: () => void;
  termsAndConditionsAccepted?: boolean;
  isNextButtonDisabled?: boolean;
}

export const activateAccountFormSchema = z.object({
  email: z.string().email(),
  firstName: z
    .string()
    .min(1, {
      message: 'First name is required',
    })
    .regex(createDoNotAcceptWithoutAlphanumericRegex(), {
      message: 'First name is required',
    }),
  lastName: z
    .string()
    .min(1, {
      message: 'Last name is required',
    })
    .regex(createDoNotAcceptWithoutAlphanumericRegex(), {
      message: 'Last name is required',
    }),
  password: z.string().regex(createCombinedPasswordValidationRegex()),
  confirmedPassword: z.string().min(1),
  mobile: z
    .string()
    .refine((phone) => hasPhoneValue(phone), {
      message: 'Mobile is required',
    })
    .refine((phone) => isPhoneValid(phone), {
      message: 'Invalid mobile number - incorrect length',
    }),
  timezone: z.string(),
  isSSOSignUp: z.boolean(),
});

export type ActivateAccountFormData = z.infer<typeof activateAccountFormSchema>;
